import { Button } from '@/components/ui/button';
import {
  Card,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from '@/components/ui/card';
import { BASE_URL } from '@/lib/client';
import { ENDPOINT_ADMIN } from '@/utils/endpoints';
import { createFileRoute, useSearch } from '@tanstack/react-router';
import { startTransition, useEffect, useState } from 'react';
import { z } from 'zod';

const searchSchema = z.object({
  error: z.string().optional(),
});

export const Route = createFileRoute('/login')({
  validateSearch: searchSchema,
  component: LoginPage,
});

function LoginPage() {
  const { error } = useSearch({ from: '/login' });
  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  useEffect(() => {
    if (globalThis.window) {
      globalThis.sessionStorage.removeItem('auth_redirecting');
    }
    if (error) {
      startTransition(() => {
        setErrorMessage(decodeURIComponent(error));
      });
    }
  }, [error]);

  const handleLogin = () => {
    if (!BASE_URL) {
      setErrorMessage('API base URL is not configured');
      return;
    }
    const oauthUrl = `${BASE_URL}${ENDPOINT_ADMIN.googleLogin}`;
    if (globalThis.window) {
      globalThis.window.location.href = oauthUrl;
    }
  };

  return (
    <div className='flex h-[100vh] items-center justify-center'>
      <Card className='w-full max-w-sm'>
        <CardHeader>
          <CardTitle>Login to your account</CardTitle>
          <CardDescription>Select your Legit Gmail account!</CardDescription>
        </CardHeader>
        <CardFooter className='flex-col gap-2'>
          {errorMessage && (
            <div className='w-full rounded-md bg-destructive/15 p-3 text-sm text-destructive'>
              {errorMessage}
            </div>
          )}
          <Button variant='outline' className='w-full' onClick={handleLogin}>
            Login with Google
          </Button>
        </CardFooter>
      </Card>
    </div>
  );
}
